export default function transformExperienceData(arg) {
  const experience = arg ?? {}; // not sure why default arguments aren't working in the browser

  experience.experienceTagIds = {};
  experience.experienceContentTypeIds = {};
  experience.contentTypesOrdered = {};
  experience.contentTypesOrdered = {};
  experience.tagsOrdered = {};
  experience.hiddenContentTypes = {};
  experience.hiddenTags = {};
  experience.tagNames = {};
  experience.experienceAssetCategoryIds = {};
  experience.assetCategoriesOrdered = {};
  experience.hiddenAssetCategories = {};
  experience.assetCategoryNames = {};

  if (experience.experienceTags?.length) {
    experience.experienceTags.forEach((experienceTag) => {
      experience.experienceTagIds[experienceTag.id] = true;
      experience.tagsOrdered[experienceTag.id] = experienceTag?.ExperienceTag?.order ?? experienceTag?.order;
      experience.hiddenTags[experienceTag.id] = experienceTag?.ExperienceTag?.hidden ?? experienceTag?.hidden;
      experience.tagNames[experienceTag.id] = experienceTag?.ExperienceTag?.name ?? experienceTag?.name;
    });
  }

  if (experience.experienceContentTypes?.length) {
    experience.experienceContentTypes.forEach((experienceContentType) => {
      experience.experienceContentTypeIds[experienceContentType.id] = true;
      experience.contentTypesOrdered[experienceContentType.id] =
        experienceContentType?.ExperienceContentType?.order ?? experienceContentType?.order;
      experience.hiddenContentTypes[experienceContentType.id] =
        experienceContentType?.ExperienceContentType?.hidden ?? experienceContentType?.hidden;
    });
  }

  if (experience.experienceAssetCategories?.length) {
    experience.experienceAssetCategories.forEach((experienceAssetCategory) => {
      const id = experienceAssetCategory.assetCategoryId || -1;
      experience.experienceAssetCategoryIds[id] = true;
      experience.assetCategoriesOrdered[id] =
        experienceAssetCategory?.ExperienceAssetCategory?.order ?? experienceAssetCategory?.order;
      experience.hiddenAssetCategories[id] =
        experienceAssetCategory?.ExperienceAssetCategory?.hidden ?? experienceAssetCategory?.hidden;
      experience.assetCategoryNames[id] =
        experienceAssetCategory?.ExperienceAssetCategory?.name ?? experienceAssetCategory?.name;
    });
  }

  return { experience };
}
